module.exports = __webpack_public_path__ + "img/sameday_cod_dg_k.8b321718.png";